<template>
  <layout-horizontal>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <app-navbar-horizontal-layout-brand v-if="false" />
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <sidebar-control-escolar
      v-if="$store.state.cuenta.session.token && permitido"
      slot="customizer"
    />
  </layout-horizontal>
</template>

<script>
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
import SidebarControlEscolar from '@core/layouts/components/sidebar-control-escolar/SidebarControlEscolar.vue'
import AppNavbarHorizontalLayoutBrand from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayoutBrand.vue'
import { rolesActions } from '@core/mixins/account-data/roles'
import {
  watch, computed, onMounted, ref,
} from '@vue/composition-api'
import store from '@/store'
import Navbar from '../components/Navbar.vue'
import useLayoutHorizontal from './useLayoutHorizontal'

export default {
  components: {
    LayoutHorizontal,
    SidebarControlEscolar,
    Navbar,
    AppNavbarHorizontalLayoutBrand,
  },
  mixins: [rolesActions],
  setup() {
    const userRole = computed(() => store.state.cuenta.rolSelected)
    const permitido = ref(false)

    onMounted(() => {
      useLayoutHorizontal(userRole.value.id).then(res => {
        permitido.value = res
      })
    })

    watch(userRole, () => {
      permitido.value = false
      useLayoutHorizontal(userRole.value.id).then(res => {
        permitido.value = res
      })
    })

    return {
      userRole,
      permitido,
    }
  },
}
</script>
